



export const BGURL = [
    '/wangyiyun-online/assets/images/bg1.jpg',
    '/wangyiyun-online/assets/images/bg1.jpg',
    '/wangyiyun-online/assets/images/bg1.jpg'];


